// extracted by mini-css-extract-plugin
export default {"root":"Highlights-root","title":"Highlights-title","highlightsList":"Highlights-highlightsList","highlight":"Highlights-highlight","icon":"Highlights-icon"};